/* Shape'd — the whole of the theme's behaviour. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  /* The store converts prices itself, so /cart.js hands back the visitor's own
     currency, not dollars. Printing a dollar sign on it was the whole bug: the
     number was right and the symbol was a lie. FMT is read off MONEY_SAMPLE,
     which the layout renders through Liquid's money filter in the live
     currency, so the bag inherits the symbol, the separators, the decimals and
     which side the symbol sits on. */
  var FMT = (function () {
    var s = window.MONEY_SAMPLE || '';
    var hit = s.match(/[0-9][0-9.,  ' ]*[0-9]/);
    if (!hit) return null;
    var num = hit[0];
    var digits = num.replace(/[^0-9]/g, '');
    var dec = digits.length >= 6 ? 2 : 0;
    var seps = num.replace(/[0-9]/g, '');
    var dot = dec === 2 && seps.length ? seps.charAt(seps.length - 1) : '';
    var group = '';
    for (var i = 0; i < seps.length - (dec === 2 ? 1 : 0); i++) { group = seps.charAt(i); }
    return {
      pre: s.slice(0, hit.index),
      suf: s.slice(hit.index + num.length),
      dec: dec, dot: dot, group: group
    };
  })();
  var money = function (c) {
    if (!FMT) { return '$' + (c / 100).toFixed(2); }
    var v = FMT.dec === 2 ? (c / 100).toFixed(2) : String(Math.round(c / 100));
    var bits = v.split('.');
    var whole = FMT.group ? bits[0].replace(/\B(?=(\d{3})+(?!\d))/g, FMT.group) : bits[0];
    return FMT.pre + whole + (bits[1] ? FMT.dot + bits[1] : '') + FMT.suf;
  };
  /* The bag builds its prices in JavaScript rather than through the money
     filter, so a currency app never sees them. Wrapping them in the same span
     the filter emits puts them back in its reach.
     Shopify.money_format is not defined on this theme, so the flag is written
     into the layout from Liquid. The DOM check is the last resort: if any price
     on the page already carries the span, the bag must carry it too. */
  var msFlag = null;
  var MS = function () {
    if (msFlag === null) {
      msFlag = window.MONEYSPAN_ON === true
        || (window.Shopify && Shopify.money_format || '').indexOf('<span') > -1
        || !!document.querySelector('span.money');
    }
    return msFlag;
  };
  var m = function (c) {
    return MS() ? '<span class=money>' + money(c) + '</span>' : money(c);
  };

  /* ---------- mobile menu ---------- */
  var mnu = $('#mnu');
  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  on($('#burger'), 'click', function () { mnu.classList.add('on'); });
  on($('#mnu-x'), 'click', function () { mnu.classList.remove('on'); });

  /* ---------- cart drawer ---------- */
  /* Everything the drawer says or does is a theme setting, carried here on
     data attributes rather than baked into this file. */
  var cart = $('#cart'), scrim = $('#scrim');
  var D = (cart && cart.dataset) || {};
  var less = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Opening the bag paints the cart we already hold, so the drawer is never
     empty for the length of a network call, and then confirms it in the
     background in case another tab changed something. */
  function open() {
    cart.classList.add('on'); scrim.classList.add('on');
    if (LAST) { draw(LAST); }
    render();
  }
  function close() { cart.classList.remove('on'); scrim.classList.remove('on'); }
  on($('#cart-open'), 'click', function (e) { e.preventDefault(); open(); });
  on($('#cart-close'), 'click', close);
  on(scrim, 'click', function () { close(); mnu.classList.remove('on'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); mnu.classList.remove('on'); } });

  /* The free delivery line and the bar are the same fact drawn twice, so they
     are recalculated together every time the cart changes. A subscription in
     the bag already earns free delivery, so it fills the bar outright. */
  function shipping(c) {
    var p = $('#cart-ship'); if (!p) return;
    var goal = parseInt(p.dataset.goal, 10) || 0;
    var sub = false;
    c.items.forEach(function (i) { if (i.selling_plan_allocation) sub = true; });
    var done = sub || (goal > 0 && c.total_price >= goal);
    if (done) { p.textContent = p.dataset.free; }
    else { p.innerHTML = (p.dataset.more || '').replace('[left]', m(Math.max(0, goal - c.total_price))); }
    var bar = $('#cart-bar');
    if (bar) {
      var pct = done ? 100 : (goal > 0 ? Math.min(100, Math.round(c.total_price / goal * 100)) : 0);
      bar.firstElementChild.style.width = pct + '%';
    }
  }

  /* Every cart endpoint hands back the whole cart, so asking /cart.js for it a
     second time was pure waiting. draw() paints a cart we already hold, and
     render() is only for when we genuinely do not have one. */
  function render() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(draw);
  }

  var LAST = null;
  function draw(c) {
    LAST = c;
    return (function (c) {
        var n = $('#cart-n');
        if (n) { n.textContent = c.item_count; n.hidden = !c.item_count; }
        var t = $('#cart-total'); if (t) t.innerHTML = m(c.total_price);
        shipping(c);
        var b = $('#cart-body'); if (!b) return c;
        if (!c.items.length) {
          var cta = b.dataset.emptyCta;
          b.innerHTML = '<div class="cd__empty"><p>' + (b.dataset.empty || '') + '</p>' +
            (cta ? '<a class="btn btn--fill" style="margin-top:18px" href="' +
                    (b.dataset.emptyUrl || '/collections/all') + '">' + cta + '</a>' : '') +
            '</div>';
          return c;
        }
        b.innerHTML = c.items.map(function (i) {
          /* What the line actually is, said plainly.

             A variant called "3 bottles + 1 free" tells you nothing about
             whether the bundle price landed, and a subscription line looked
             identical to a one time order, which is the sort of thing people
             abandon a cart over. Both now say what they are. */
          var tags = '';

          var sub = i.selling_plan_allocation;
          if (sub) {
            /* Prefer the plan's own wording, since that is what the customer
               agreed to, and fall back to the editable line in the settings. */
            /* Shopify's own selling plan name is written for the checkout, not for
               a 300px wide bag. "Deliver every month, 15% off" plus a note wraps
               to three lines and bursts the pill. If a short label is set in the
               theme it wins, and the plan name is only used as a fallback. */
            var planName = (sub.selling_plan && sub.selling_plan.name) || '';
            var label = b.dataset.subLabel || planName;
            tags += '<div class="ci__sub">' +
                      (label ? label : '') +
                      (label && b.dataset.subNote ? ' · ' : '') +
                      (b.dataset.subNote || '') +
                    '</div>';
          }

          /* A saving is only claimed when there is one. Count every number in
             the variant name so "3 bottles + 1 free" is four units, then
             compare what a single would have cost. */
          /* Count only the numbers in the FIRST part of the variant name.
             "1 bottle · 200 ml" was being read as 201 units because the size
             counted too, which is why a single bottle claimed a bundle price. */
          var units = 0;
          (i.variant_title || '').split('·')[0].split(/[^0-9]+/).forEach(function (n) {
            if (n) units += parseInt(n, 10);
          });
          var saved = (i.original_line_price || 0) - (i.final_line_price || 0);
          if (units > 1 || saved > 0) {
            tags += '<div class="ci__save">' +
                      (b.dataset.bundleNote || 'Bundle price applied') +
                      (saved > 0 ? ' · you save ' + m(saved) : '') +
                    '</div>';
          }

          return '<div class="ci" data-k="' + i.key + '">' +
            '<div class="ci__m">' + (i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') + '" alt="">' : '') + '</div>' +
            '<div><div class="ci__n">' + i.product_title + '</div>' +
            '<div class="ci__v">' + (i.variant_title || '') + '</div>' +
            tags +
            '<div class="ci__row">' +
              '<div class="ci__q"><button data-d="-1" aria-label="One fewer">&minus;</button><span>' + i.quantity + '</span><button data-d="1" aria-label="One more">+</button></div>' +
              '<button type="button" class="ci__x">' + (b.dataset.remove || 'Remove') + '</button>' +
            '</div>' +
            '</div><div>' + m(i.final_line_price) + '</div></div>';
        }).join('');
        reconvert();
        upsell(c);
        return c;
    })(c);
  }

  /* ---------- the upgrade offer in the bag ----------

     Two offers, in priority order:
       1. a bigger pack of something already in the bag, when it costs less per
          unit than what they picked
       2. the subscription, when the line is a one time order

     Nothing here is hardcoded to a product. The variant ladder and the selling
     plan are read from /products/<handle>.js, so a new product with packs and a
     plan gets this for free. One fetch per product, cached for the page. */
  var PCACHE = {};
  function prod(handle){
    if(PCACHE[handle]) return PCACHE[handle];
    PCACHE[handle] = fetch('/products/' + handle + '.js', { headers:{Accept:'application/json'} })
      .then(function(r){ return r.ok ? r.json() : null; })
      .catch(function(){ return null; });
    return PCACHE[handle];
  }

  /* Same counting rule the line items use: only the first part of the variant
     title, so "3 bottles + 1 free · 800 ml" is four and not eight hundred. */
  function unitsOf(title){
    var n = 0;
    (title || '').split('\u00b7')[0].split(/[^0-9]+/).forEach(function(x){ if(x) n += parseInt(x,10); });
    return n || 1;
  }

  function fill(tpl, map){
    return String(tpl || '').replace(/\[(\w+)\]/g, function(_, k){
      return map[k] === undefined ? '' : map[k];
    });
  }

  function upsell(c){
    var box = $('#cart-up');
    if(!box) return;
    if(!c || !c.items || !c.items.length){ box.hidden = true; return; }

    /* the biggest line is the one worth upgrading */
    var line = c.items.slice().sort(function(a,b){ return b.final_line_price - a.final_line_price; })[0];
    var idx  = c.items.indexOf(line) + 1;

    prod(line.handle).then(function(P){
      if(!P){ box.hidden = true; return; }

      var here    = P.variants.filter(function(v){ return v.id === line.variant_id; })[0];
      if(!here){ box.hidden = true; return; }
      var hereU   = unitsOf(here.title) * line.quantity;
      var hereEach= here.price / unitsOf(here.title);

      /* 1. a bigger pack that is genuinely cheaper per unit */
      if(box.dataset.packOn === '1'){
        var better = null;
        P.variants.forEach(function(v){
          if(!v.available || v.id === here.id) return;
          var u = unitsOf(v.title);
          if(u <= hereU) return;
          var each = v.price / u;
          if(each >= hereEach) return;
          if(!better || u > unitsOf(better.title)) better = v;
        });
        if(better){
          var bu    = unitsOf(better.title);
          var saved = (hereEach * bu) - better.price;
          box.innerHTML =
            '<h4>' + box.dataset.packTitle + '</h4>' +
            '<p>' + fill(box.dataset.packLine, {
              pack:  better.title.split('\u00b7')[0].trim(),
              price: m(better.price),
              each:  m(Math.round(better.price / bu)),
              saved: m(Math.max(0, Math.round(saved)))
            }) + '</p>' +
            '<button type="button" class="btn btn--fill" data-up="pack" ' +
              'data-line="' + idx + '" data-key="' + line.key + '" data-id="' + better.id + '" ' +
              'data-plan="' + (line.selling_plan_allocation ? line.selling_plan_allocation.selling_plan.id : '') + '">' +
              box.dataset.packCta + '</button>';
          box.hidden = false;
          return;
        }
      }

      /* 2. otherwise, the subscription */
      if(box.dataset.subOn === '1' && !line.selling_plan_allocation){
        var grp  = (P.selling_plan_groups || [])[0];
        var plan = grp && grp.selling_plans && grp.selling_plans[0];
        if(plan){
          var adj  = (plan.price_adjustments || [])[0];
          var now  = here.price;
          if(adj && adj.value_type === 'percentage') now = Math.round(here.price * (100 - adj.value) / 100);
          else if(adj && adj.value_type === 'fixed_amount') now = Math.max(0, here.price - adj.value);
          else if(adj && adj.value_type === 'price') now = adj.value;
          if(now < here.price){
            box.innerHTML =
              '<h4>' + box.dataset.subTitle + '</h4>' +
              '<p>' + fill(box.dataset.subLine, {
                price: m(now * line.quantity),
                was:   m(here.price * line.quantity),
                saved: m((here.price - now) * line.quantity)
              }) + '</p>' +
              '<button type="button" class="btn btn--fill" data-up="sub" ' +
                'data-line="' + idx + '" data-key="' + line.key + '" data-plan="' + plan.id + '">' +
                box.dataset.subCta + '</button>';
            box.hidden = false;
            return;
          }
        }
      }

      box.hidden = true;
    });
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-up]');
    if(!b) return;
    e.preventDefault();
    var box = $('#cart-up'); if(box) box.classList.add('busy');

    var body, url;
    if(b.dataset.up === 'sub'){
      /* same variant, plan added - change.js takes the plan directly */
      url  = '/cart/change.js';
      body = { id: b.dataset.key, quantity: 1, selling_plan: parseInt(b.dataset.plan, 10) };
      fetch(url, { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
                   body: JSON.stringify(body) })
        .then(function(r){ return r.json(); })
        .then(draw)
        .catch(render)
        .then(function(){ if(box) box.classList.remove('busy'); });
      return;
    }

    /* a different variant cannot be swapped in place, so the old line goes and
       the new one is added with the same plan if there was one */
    fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
        body: JSON.stringify({ id: b.dataset.key, quantity: 0 }) })
      .then(function(){
        var add = { id: parseInt(b.dataset.id, 10), quantity: 1 };
        if(b.dataset.plan) add.selling_plan = parseInt(b.dataset.plan, 10);
        return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
          body: JSON.stringify(add) });
      })
      .then(render)
      .catch(render)
      .then(function(){ if(box) box.classList.remove('busy'); });
  });

  /* The bag is built after the page has loaded, so a currency app that only
     converts what was on the page at load never sees these prices. This pokes
     whichever one is installed, using whatever hook it exposes, and does
     nothing at all when none is there. */
  function reconvert(){
    try{
      var V = window.Vitals || window.VITALS;
      if(V && V.currency && typeof V.currency.convert === 'function'){ V.currency.convert(); return; }
      if(typeof window.doubly_currency_convert === 'function'){ window.doubly_currency_convert(); return; }
      if(typeof window.Currency === 'object' && typeof window.Currency.convertAll === 'function'){
        window.Currency.convertAll(window.Currency.currentCurrency, window.Currency.currentCurrency); return;
      }
      /* last resort: most apps watch for this, and it is harmless otherwise */
      document.dispatchEvent(new CustomEvent('currency:refresh'));
      window.dispatchEvent(new Event('resize'));
    }catch(e){}
  }

  /* One request, not two, and the number moves before it is sent.
     Pressing plus used to change the cart, then fetch the whole cart again
     before anything on screen moved, so two round trips stood between the
     click and the feedback. change.js already returns the cart, so the second
     trip is gone, and the quantity is painted immediately. */
  function setQty(row, q) {
    if (!row || row.classList.contains('busy')) return;
    q = Math.max(0, q);
    var n = row.querySelector('.ci__q span');
    if (n) { n.textContent = q; }
    row.classList.add('busy');
    if (q === 0) { row.style.display = 'none'; }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: row.dataset.k, quantity: q })
    })
      .then(function (r) { return r.json(); })
      .then(draw)
      .catch(function () { row.classList.remove('busy'); row.style.display = ''; return render(); });
  }

  document.addEventListener('click', function (e) {
    var x = e.target.closest('.ci__x');
    if (x) { e.preventDefault(); setQty(x.closest('.ci'), 0); return; }
    var b = e.target.closest('.ci__q button'); if (!b) return;
    var row = b.closest('.ci');
    var n = row.querySelector('.ci__q span');
    setQty(row, parseInt(n.textContent, 10) + parseInt(b.dataset.d, 10));
  });

  /* ---------- add to bag ---------- */
  /* The bag icon bump. */
  function bump() {
    var t = $('#cart-open'); if (!t || less) return;
    t.classList.remove('bump');
    void t.offsetWidth;              /* restart the animation on a repeat add */
    t.classList.add('bump');
    setTimeout(function () { t.classList.remove('bump'); }, 600);
  }

  /* A clone of whatever image is nearest the button, thrown at the bag icon.
     It is a fixed position copy, so it never disturbs the page it came from,
     and it removes itself when it lands. */
  function fly(form) {
    var target = $('#cart-open');
    var box = form.closest('.pc') || form.closest('section') || document;
    var img = box.querySelector('img') || $('img');
    if (!img || !target || less) return;
    var a = img.getBoundingClientRect(), z = target.getBoundingClientRect();
    if (!a.width) return;
    var size = Math.min(a.width, 150);
    var el = document.createElement('img');
    el.src = img.currentSrc || img.src;
    el.className = 'fly';
    el.style.cssText += 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + size +
      'px;height:' + size + 'px;opacity:1';
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      var dx = z.left + z.width / 2 - (a.left + size / 2);
      var dy = z.top + z.height / 2 - (a.top + size / 2);
      el.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12)';
      el.style.opacity = '.2';
    });
    setTimeout(function () { el.remove(); }, 800);
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[action*="/cart/add"]'); if (!f) return;
    e.preventDefault();
    var mode = D.atc || 'flybump';
    var btn = f.querySelector('[type=submit]');
    var was = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = (D.adding || 'Adding') + '…'; }
    if (mode === 'fly' || mode === 'flybump') fly(f);
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (mode === 'bump' || mode === 'flybump') bump();
        if (btn) {
          btn.disabled = false;
          btn.textContent = mode === 'none' ? was : (D.done || 'Added');
          setTimeout(function () { btn.textContent = was; }, 1400);
        }
        render();
        if (D.autoopen === '1') setTimeout(open, parseInt(D.delay, 10) || 0);
        /* nothing else: render() already refreshed the count and the bag */
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = was; } });
  });

  render();
})();


/* Pack ladder on the product cards: the headline price follows the selected
   pack, so a card showing $29.99 drops to $19.99 the moment someone picks the
   single. The radios are name="id", so the form itself needs no JS - this is
   only the price readout. */
document.addEventListener('change', function (e) {
  var el = e.target;
  if (!el || el.name !== 'id') return;
  var src = el.tagName === 'SELECT' ? el.selectedOptions[0] : el;
  if (!src || el.tagName !== 'SELECT' && el.type !== 'radio') return;
  var card = el.closest('.pc');
  if (!card) return;
  var out = card.querySelector('[data-price-out]');
  if (!out) return;
  var was = src.dataset.was;
  out.innerHTML = '<span>' + src.dataset.price + '</span>' + (was ? '<s>' + was + '</s>' : '');
});


/* ---------------------------------------------------------------------------
   SWIPE BARS
   Every row you can swipe on a phone gets the same bar under it, so the page
   never asks you to guess that there is more off to the right. One place, not
   nine copies: the list below is the only thing to touch when a new scrolling
   row is built.

   The fill is the VISIBLE FRACTION of the row and it travels that same
   fraction of the track, so it reads as a scrollbar - width tells you how many
   there are, position tells you how far along you are.

   Endless carousels (cards, shop row) hold three copies of their set and jump
   silently between them. Measuring those against scrollWidth would make the
   bar leap when they re-park, so they are measured within ONE set instead and
   the bar simply loops. Mark those rows data-loop="3".
--------------------------------------------------------------------------- */
(function () {
  /* Every scrolling row EXCEPT the product row on the home page - that one
     section is the only place Ota wanted the bar gone. Add or remove a
     selector here; nothing else needs touching.
       .cds        cards carousel
       .rl__row    reels wall
       .cg2__scroll comparison grid
       .ugc        UGC row
       .cmp__s     compare table
       .lb__view   lookbook
       .ba         before / after carousel
     The product gallery is deliberately absent - neither the main image nor
     the thumbnail rail carries one. */
  var ROWS = ['.cds', '.rl__row', '.cg2__scroll', '.ugc', '.cmp__s',
              '.lb__view', '.ba'];

  function paint(row, fill) {
    var view = row.clientWidth;
    if (!view) return;
    var copies = parseInt(row.dataset.loop || '1', 10) || 1;
    var span = row.scrollWidth / copies;          /* one set */
    var pos = row.scrollLeft;
    if (copies > 1) { pos = ((pos % span) + span) % span; }

    if (span - view <= 1) { row.__sb.hidden = true; return; }
    row.__sb.hidden = false;

    var frac = Math.min(1, view / span);
    var travel = Math.min(1, Math.max(0, pos / (span - view)));
    fill.style.width = (frac * 100) + '%';
    fill.style.transform = 'translateX(' + (travel * (1 / frac - 1) * 100) + '%)';
  }

  function attach(row) {
    if (row.__sb) return;
    var bar = document.createElement('div');
    bar.className = 'swipebar';
    bar.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('span');
    bar.appendChild(fill);
    row.insertAdjacentElement('afterend', bar);
    row.__sb = bar;

    var queued = false;
    var run = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; paint(row, fill); });
    };
    row.addEventListener('scroll', run, { passive: true });
    window.addEventListener('resize', run);
    /* clones and lazy images land after first paint, so measure again */
    setTimeout(run, 60);
    setTimeout(run, 600);
    run();
  }

  function scan() {
    ROWS.forEach(function (sel) {
      [].forEach.call(document.querySelectorAll(sel), function (row) {
        if (row.dataset.noSwipebar) return;
        attach(row);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
})();


/* ---------------------------------------------------------------------------
   VIDEO AUTOPLAY
   Every background video on the site, in one place: hero, shape tabs, how to
   use, reels. The markup already carries autoplay/muted/playsinline, but that
   is not enough on iOS - `muted` has to be set as a PROPERTY, not only as an
   attribute, or Safari refuses and falls back to a poster with a grey play
   button. Shopify's video_tag also wraps the <video> in a custom element, so
   the attributes on the wrapper never reach the media element.

   What this cannot beat: iOS Low Power Mode blocks autoplay outright. For that
   case the first touch anywhere on the page starts them.
--------------------------------------------------------------------------- */
(function () {
  var seen = [];

  function prime(v) {
    try {
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.controls = false;
      v.removeAttribute('controls');
      if (!v.hasAttribute('loop')) v.loop = true;
    } catch (e) {}
  }

  function nudge(v) {
    if (!v || v.dataset.noAuto === 'true') return;
    if (v.closest && v.closest('[hidden]')) return;      /* a tab that is not showing */
    prime(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function scan() {
    [].forEach.call(document.querySelectorAll('video'), function (v) {
      if (seen.indexOf(v) === -1) { seen.push(v); prime(v); }
    });
    seen.forEach(nudge);
  }

  /* pause what has scrolled away, restart it when it comes back */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) nudge(v);
        else { try { v.pause(); } catch (err) {} }
      });
    }, { rootMargin: '120px' });
    var watch = function () {
      [].forEach.call(document.querySelectorAll('video'), function (v) {
        if (!v.dataset.ioOn) { v.dataset.ioOn = '1'; io.observe(v); }
      });
    };
    document.addEventListener('DOMContentLoaded', watch);
    window.addEventListener('load', watch);
    setTimeout(watch, 800);
  }

  ['DOMContentLoaded', 'load'].forEach(function (e) {
    window.addEventListener(e, scan);
  });
  setTimeout(scan, 400);
  setTimeout(scan, 1500);

  /* Low Power Mode and any other refusal: the first real gesture releases it */
  ['touchstart', 'pointerdown', 'click', 'scroll'].forEach(function (e) {
    window.addEventListener(e, function once() {
      scan();
      window.removeEventListener(e, once);
    }, { passive: true });
  });

  document.addEventListener('shopify:section:load', scan);
})();

/* ------------------------------------------------------------------
   Lazy video.

   Every decorative clip on this theme used to carry autoplay. An
   autoplaying video downloads the whole file the moment it is parsed,
   whatever preload says, so a page with nine reels pulled nine full
   videos before anyone had scrolled. That was 195MB on the hair page.

   Now nothing carries autoplay and nothing preloads. A clip starts
   only when it scrolls into view and pauses when it leaves, so a
   visitor downloads the two or three they actually look at.
------------------------------------------------------------------ */
(function(){
  if(!('IntersectionObserver' in window)) return;

  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Is it really on screen RIGHT NOW. The observer fires from a snapshot
     taken earlier, and during load that snapshot is of a page that had not
     grown to full height yet, so it can be wrong by thousands of pixels. */
  function onScreen(v){
    var r = v.getBoundingClientRect();
    if(!r.height || !r.width) return false;
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < h;
  }

  function wake(v){
    if(v.dataset.nolazy) return;
    if(!onScreen(v)) return;
    /* Do NOT touch preload here. Setting it to auto is sticky: once a clip is
       committed to downloading, pause() does not stop it, so a single moment
       of visibility during a layout shift left it buffering off screen for
       ever. play() on a preload="none" clip starts the fetch by itself, which
       is all we want, and load() below can take it back. */
    var p = v.play();
    if(p && p.catch) p.catch(function(){ /* low power mode. poster stays up. */ });
  }

  function sleep(v){
    try{
      v.pause();
      /* pause leaves the fetch running. load() aborts it and resets the clip
         to nothing loaded, which is what actually saves the bytes. Only worth
         doing while it is still buffering - a clip that has real frames is
         cheap to leave alone and jarring to reset. */
      if(v.readyState < 3) v.load();
    }catch(err){}
  }

  /* A page settling after load moves things past the viewport edge. Waiting a
     beat before starting anything means a clip that flicks through view while
     images reflow never begins downloading at all. */
  var pending = new WeakMap();
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var v = e.target;
      var t = pending.get(v);
      if(t){ clearTimeout(t); pending.delete(v); }
      if(e.isIntersecting){
        if(calm) return;
        pending.set(v, setTimeout(function(){ pending.delete(v); wake(v); }, 150));
      } else {
        sleep(v);
      }
    });
  }, { rootMargin: '0px', threshold: 0.25 });

  function bind(){
    [].slice.call(document.querySelectorAll('video')).forEach(function(v){
      if(v.dataset.lazybound || v.dataset.nolazy) return;
      v.dataset.lazybound = '1';
      io.observe(v);
    });
  }

  /* The deterministic backstop. Observers race each other while the page is
     settling, and whichever play() lands last wins, which is how six reels
     ended up buffering off screen. This sweeps the whole page once things
     have stopped moving and stops anything that is not actually visible. */
  function sweep(){
    [].slice.call(document.querySelectorAll('video')).forEach(function(v){
      if(v.dataset.nolazy) return;
      if(!onScreen(v) && (!v.paused || v.networkState === 2)) sleep(v);
    });
  }

  bind();
  document.addEventListener('shopify:section:load', bind);
  /* reels tabs and variant swaps can reveal clips that were hidden */
  document.addEventListener('click', function(){ setTimeout(bind, 80); }, true);

  window.addEventListener('load', function(){
    sweep();
    setTimeout(sweep, 600);
    setTimeout(sweep, 2000);
  });
  window.addEventListener('resize', function(){ clearTimeout(window.__lzsw);
    window.__lzsw = setTimeout(sweep, 250); });
})();
